<template>
  <v-tabs
    fixed-tabs
    dark
    class="mt-n8"
  >
    <v-tabs-slider color="#FAD84B"></v-tabs-slider>
    <v-tab>
      NEARBY
    </v-tab>
    <v-tab>
      MATCHES
    </v-tab>
    <v-tab>
      ALL
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: 'SearchTabs'
}
</script>

<style scoped>

</style>
